import { render, staticRenderFns } from "./PatientBedsore.vue?vue&type=template&id=8739fda2&"
import script from "./PatientBedsore.vue?vue&type=script&lang=ts&"
export * from "./PatientBedsore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports